import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Dashboard from "@/pages/Dashboard";
import Book from "@/pages/Book";
import BookingDetail from "@/pages/BookingDetail";
import BookingSuccess from "@/pages/BookingSuccess";
import PayPalReturn from "@/pages/PayPalReturn";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/legal/Privacy";
import Terms from "@/pages/legal/Terms";
import Refund from "@/pages/legal/Refund";
import ServiceAgreement from "@/pages/legal/ServiceAgreement";
import Damage from "@/pages/legal/Damage";

function AppRouter() {
  const location = useLocation();
  // Synchronously handle Emergent Google auth callback (URL fragment session_id)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/book" element={<Book />} />
      <Route path="/booking/success" element={<BookingSuccess />} />
      <Route path="/booking/paypal/return" element={<PayPalReturn />} />
      <Route path="/booking/:id" element={<BookingDetail />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/legal/privacy" element={<Privacy />} />
      <Route path="/legal/terms" element={<Terms />} />
      <Route path="/legal/refund" element={<Refund />} />
      <Route path="/legal/service-agreement" element={<ServiceAgreement />} />
      <Route path="/legal/damage" element={<Damage />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
